import React from "react";
import {
  FileText,
  DollarSign,
  UserCheck,
  Building,
  BarChart,
  FileCheck,
} from "lucide-react";
import SectionHeading from "../ui/SectionHeading";
import ServiceCard from "../ui/ServiceCard";
import CTAButton from "../ui/CTAButton";

const services = [
  {
    title: "Taxation",
    description:
      "Complete tax planning, preparation, filing, Appeal & Tribunal services for individuals and corporate businesses to optimize your tax position.",
    icon: <FileText size={24} />,
    link: "/services#taxation",
  },
  {
    title: "Value Added Tax (VAT)",
    description:
      "Expert assistance with VAT registration, return filing, Appeal, Tribunal and compliance to meet regulatory requirements.",
    icon: <DollarSign size={24} />,
    link: "/services#vat",
  },
  {
    title: "RJSC Related Work",
    description:
      "Full support for company formation, return filing, share transfer, allotment and other Joint Stock Companies affairs.",
    icon: <Building size={24} />,
    link: "/services#rjsc",
  },
  {
    title: "BIDA Related Work",
    description:
      "Comprehensive guidance for company registration (Local and Foreign),VISA recommendation, work permit (issue, cancellation and ammendment), Industrial IRC adhoc etc.",
    icon: <UserCheck size={24} />,
    link: "/services#bida",
  },
  {
    title: "Accounting Solutions",
    description:
      "Professional accounting services including chart of accounts planning with taxation, Third party accounting service, Management accounting and financial reporting.",
    icon: <BarChart size={24} />,
    link: "/services#accounting",
  },
  {
    title: "Company Matters & Licenses",
    description:
      "Expert assistance with company consultancy, regulatory compliance, and obtaining necessary business licenses from Govt. authorities.",
    icon: <FileCheck size={24} />,
    link: "/services#company",
  },
];

const ServicesOverview = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Our Services"
          subtitle="We provide comprehensive Tax, VAT, RJSC, BIDA and business consultancy services to help you navigate complex financial landscapes and achieve your goals."
          center
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              title={service.title}
              description={service.description}
              icon={service.icon}
              link={service.link}
            />
          ))}
        </div>

        <div className="text-center mt-16">
          <CTAButton to="/services">View All Services</CTAButton>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
